<template>

    <footer id="footer" class="bg-full" style="background-image: url(/static/images/img13.jpg);">
        <!-- footer holder of the page -->
        <div class="footer-holder container">
            <div class="row">
                <!--<div class="col-xs-12 col-sm-6 col-md-6">
                    <h3>Om P. Pedersen & Søn</h3>
                    <p>
                        P. Pedersen & Søn ApS er et transport firma, som startede i 1921.
                        Det køres nu af Karsten Bil Pedersen, som er 3. generation.
                    </p>
                    <!-- Socail network of the page -->
                    <!--<ul class="list-unstyled socail-network">
                        <li><a href="#"><i class="fab fa-facebook fa-2x"></i> Besøg os på Facebook</a></li>
                    </ul>-->
                    <!--<div class="btn-holder alt">
                        <a href="#" class="btn-primary text-center text-uppercase active md-round">
                            Gå til Kemi-Oil
                            &nbsp;&nbsp;<i class="fas fa-chevron-right" />
                        </a>
                    </div>
                </div>-->
                <!--<div class="col-xs-12 col-sm-12 col-md-2"></div>-->
                <!--<div class="col-xs-12 col-sm-12 col-md-4">
                    <h3>Kontakt os</h3>
                    <ul class="list-unstyled contactlist">
                        <li style="color:#fff">
                            <i class="icon fal fa-home" />
                            <address>Nørrebro 23<br>5985 Søby Ærø</address>
                        </li>
                        <li>
                            <i class="icon fal fa-phone" />
                            <span class="tel">
                                <a href="tel:+4540436078">40 43 60 78</a>
                            </span>
                        </li>
                        <li>
                            <i class="icon fal fa-envelope" />
                            <span class="mail">
                                <a href="mailto:karsten@p-pedersen.dk">karsten@p-pedersen.dk</a>
                            </span>
                        </li>
                    </ul>
                </div>-->
                <div class="col-lg-3 col-md-6 col-sm-12">
                    <h3>Kontakt os</h3>
                </div>
                <div class="col-lg-3 col-md-6 col-sm-12">
                    <ul class="list-unstyled contactlist">
                        <li style="color:#fff">
                            <i class="icon fal fa-phone" />
                            <span class="tel">
                                <a href="tel:+4540436078">40 43 60 78</a>
                            </span>
                        </li>
                    </ul>
                </div>
                <div class="col-lg-3 col-md-6 col-sm-12">
                    <ul class="list-unstyled contactlist">
                        <li style="color:#fff">
                            <i class="icon fal fa-envelope" />
                            <span class="mail">
                                <a href="mailto:karsten@p-pedersen.dk">karsten@p-pedersen.dk</a>
                            </span>
                        </li>
                    </ul>
                </div>
                <div class="col-lg-3 col-md-6 col-sm-12">
                    <ul class="list-unstyled contactlist">
                        <li style="color:#fff">
                            <i class="icon fal fa-home" />
                            <address>Nørrebro 23, 5985 Søby Ærø</address>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <!-- footer area of the page -->
        <div class="footer-area">
            <div class="container">
                <div class="row">
                    <div class="col-xs-12 text-center">
                        <p>{{ date }} © P. Pedersen & Søn
                            &nbsp;&nbsp;|&nbsp;&nbsp;
                            CVR: 60098018
                            &nbsp;&nbsp;|&nbsp;&nbsp;
                            Udviklet af <a class="brand-link" href="https://deveo.dk" target="_blank" rel="noopener">Deveo</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </footer>

</template>

<style lang="scss" scoped>
#footer {
    min-height: 0;
}

#footer .contactlist .icon {
    margin: 4px 15px 0 0;
}

#footer .contactlist a {
    color: #fff;
}

.btn-holder a {
    background: transparent;
    border-color: #fff;
    color: #fff;
}

.footer-holder {
    padding: 50px 0 20px 0 !important;
}

@media screen and (max-width:768px) {
    .footer-holder{
        text-align: center;

        * {
            text-align: center !important;
            float: none !important;
        }

        i {
            margin: 0 !important;
        }

        address {
            width: 100% !important;
        }
    }
}

.footer-area {
    opacity: .5;

    a.brand-link {
        color: #fff;
        transition: .3s ease all;
        border-bottom: dotted 1px #fff;

        &:hover {
            border-bottom: solid 1px #fff;
        }
    }
}
</style>

<script>
    export default {
        data () {
            return {
                date: ''
            }
        },
        created () {
            this.date = (new Date().getFullYear())
        }
    }
</script>



// WEBPACK FOOTER //
// footer.vue?77110f71